import React from 'react';


class NotFound extends React.Component{
	render(){
		return (
				<h2> NotFound!!</h2>
			)
	}
}

export default  NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js